// #region Imports
import { defineComponent } from "vue";
// #endregion
// #region Core
export default defineComponent({
    // #region Class
    name: 'g-wizard-header',
    // #endregion
    // #region Data
    props: {
        page: {
            type: Object,
            required: true,
        },
        index: {
            type: Number,
            required: true,
            default: 0,
        },
        isActive: {
            type: String,
            required: true,
            default: false
        }
    },
    // #endregion
});
// #endregion
